import { render } from "./RewardModal.vue?vue&type=template&id=998a3e9a&scoped=true"
import script from "./RewardModal.vue?vue&type=script&lang=js"
export * from "./RewardModal.vue?vue&type=script&lang=js"

import "./RewardModal.vue?vue&type=style&index=0&id=998a3e9a&scoped=true&lang=css"

import exportComponent from "/Users/nutsudaploysopon/Desktop/DevFinite/Octopus Co.,Ltd./Ncare/NCare-WebApp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-998a3e9a"]])

export default __exports__